import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './styles.css';

/**
 * `refetchOnWindowFocus` is on, deliberately.
 *
 * It was off, which meant returning to the tab never refreshed anything: combined with a ten
 * second `staleTime`, a change made somewhere other than this browser — by the assistant over
 * MCP, from a phone, by the drift job — did not appear until the user happened to mutate
 * something and trigger an invalidation. For an application whose whole premise is that an
 * assistant edits your tasks alongside you, silently showing a stale plan is the wrong default.
 *
 * The `staleTime` stays: it is what stops every screen change re-fetching the goal tree, and
 * focus is a much better signal for "you have been away, this may have moved" than mount is.
 */
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 10_000, refetchOnWindowFocus: true } },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
